import React from 'react';
import { Container } from '../../components/Container/Container';
import { Form, useChanges } from '../../components/Form/Form';
import { Card } from '../../components/Card/Card';
import { Datepicker } from '../../components/Form/Datepicker/Datepicker';

import { t } from '../../locales/translate';
import { useMeta } from '../../model/meta';
import { Button } from '../../components/Button/Button';
import './BookKeepingExport.css';
import { TimeFrame } from '../../util/util';
import { useTask } from '../../model/data';
import { runExport } from '../../model/exports';

export const BookKeepingExport = (): JSX.Element => {
  const [changes, , model, trackChanges] = useChanges<{ dateRange: TimeFrame }>({
    dateRange: [undefined, undefined],
  });
  const { loading, run } = useTask({ handleError: true });

  useMeta({
    title: t.model.bookkeeping._name,
  });

  async function handleExport(): Promise<void> {
    if (model.dateRange[0] && model.dateRange[1]) {
      run(
        runExport({
          type: 'book_keeping',
          arguments: {
            startDate: model.dateRange[0],
            endDate: model.dateRange[1],
          },
        })
      );
    }
  }

  function canSubmit(): boolean {
    return !!changes?.dateRange?.[0] && !!changes?.dateRange?.[1];
  }

  return (
    <Container>
      <Card title={t.model.bookkeeping.bookKeepingExport}>
        <Form model={model} onInput={trackChanges}>
          {() => {
            return (
              <>
                <Datepicker name="dateRange" rangeOfDays label={t.model.datetime.timeframe} />
                <div className="book-keeping__footer">
                  <Button
                    disabled={!canSubmit()}
                    type={'primary'}
                    title={t.actions.export('')}
                    onClick={handleExport}
                    loading={loading}
                  ></Button>
                </div>
              </>
            );
          }}
        </Form>
      </Card>
    </Container>
  );
};
